<template>
    <div class="content">
        <img :src="require('@/assets/img/hld.png')" alt="">
        <p>为了更好的定位您的职业发展，请您完成“霍兰德测评”</p>
        <van-button type="danger" @click="hldtest">开始测试</van-button>
    </div>
</template>

<script>
    export default {
        methods:{
            // 跳转霍兰德测试
            hldtest(){
                // window.location.href="http://eva.zhulong.com?h_id=" + sessionStorage.getItem("ID")
                // window.location.href=window.location.origin + '/interview/interest?resume_id=' + sessionStorage.getItem("ID")
                this.$router.push({
                    path: 'interest',
                    query: {
                        resume_id: sessionStorage.getItem("ID")
                    }
                })
            },
        }
    }
</script>

<style scoped lang="less">
.content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
img {
    width: 100%;
}
p {
    font-size: 24px;
    color: #404040;
    text-align: center;
    padding-top: 40px;
    padding-bottom: 40px;
}
/deep/ .van-button {
    width: 90%;
    border-radius: 5px;
}
</style>